import React, { Component } from 'react';
import cards from '../assets/img_charity_cards.png';
import './Splash.css';
import './Features.css';
import './Breakdown.css';
import './Call.css';
import one from '../assets/img_select_charity.png';
import two from '../assets/img_subscribe.png';
import three from '../assets/img_manage.png';
import breakdown from '../assets/img_breakdown.png';
import breakdownMobile from '../assets/img_breakdown_mobile.png';
import charity from '../assets/img_charity_card.png';
import profile from '../assets/img_profile.png';
import SignUp from '../Components/Form/SignUp';
import { withMedia } from 'react-media-query-hoc';
import { validateEmail } from '../Helpers/form';
import * as firebase from 'firebase';

export default withMedia(class Users extends Component {
  state = {
    signedUp: false,
    email: '',
    error: false
  }

  onChange = e => {
    this.setState({
      error: false,
      email: e.target.value
    });
  }

  signUp = e => {
    e.preventDefault();

    const error = !validateEmail(this.state.email);

    this.setState({
      error: error,
    });

    if (error) return;

    firebase.firestore()
      .collection('emails')
      .add({ email: this.state.email })
      .then(() => this.setState({ signedUp: true }))
      .catch(() => this.setState({ error: true }));
  }

  render() {
    return (
      <main className="page">
        <section className="splash">
          {this.props.media.mobile
            ? null
            : <div className="cards">
                <img alt="Charity Cards Example" className="charity-cards" src={cards}/>
              </div>
          }
          <SignUp
            error={this.state.error}
            onChange={this.onChange}
            value={this.state.email}
            onSubmit={this.signUp}
            signedUp={this.state.signedUp}
            buttonText="Sign up"
          >
            <h1>
              Charity{this.props.media.mobile ? null : <br/>} donations{this.props.media.mobile ? null : <br/>} made simple
            </h1>
            <p>
              Easily donate and manage your donations to your chosen charities with clarity. Sign up now to get early access when we launch.
            </p>
          </SignUp>
        </section>
        <section className="features container">
          <ul>
            <li>
              <p className="number">1</p>
              <img src={one} alt="Charities"/>
              <h2>Select a Charity</h2>
              <p>There's a charity for everyone, we guarantee you'll find a few that match your interests</p>
            </li>
            <li>
              <p className="number">2</p>
              <img src={two} alt="Charities"/>
              <h2>Subscribe</h2>
              <p>Choose how much you want to donate each month</p>
            </li>
            <li>
              <p className="number">3</p>
              <img src={three} alt="Subscription Example"/>
              <h2>Manage</h2>
              <p>Keep track of which charities you're donating to and when you're donating to them</p>
            </li>
          </ul>
        </section>
        <section className="breakdown container">
          <h2>Clearly see how your donation is spent</h2>
          <p> You can see exactly how much of your donation goes towards the charity's cause with donation breakdowns</p>
          <img alt="Donation Breakdowns" src={this.props.media.mobile ? breakdownMobile : breakdown}/>
        </section>
        <section className="features-extended container">
          <div className="top-text">
            <h2>Stop &amp; pause donations</h2>
            <p> Stopping your donation to charity is as easy as flicking a switch. Then when you're ready to donate again, just turn it back on.</p>
          </div>
          <div className="top-img">
            <img alt="Charity interface example" src={charity}/>
          </div>
          <div className="bottom-img">
            <img alt="Profile example" src={profile}/>
          </div>
          <div className="bottom-text">
            <h2>Let other's know who you're helping</h2>
            <p>The charities you back can be seen on your profile. It's a great way to show what you're about.</p>
          </div>
        </section>
        <section className="call">
          <SignUp
            error={this.state.error}
            onChange={this.onChange}
            value={this.state.email}
            onSubmit={this.signUp}
            signedUp={this.state.signedUp}
            buttonText="Sign up"
          >
            Get Early Access
          </SignUp>
        </section>
      </main>
    );
  }
});



// WEBPACK FOOTER //
// ./src/Pages/Users.js